module.exports = __webpack_public_path__ + "static/akynara-5ea2258d131193e5fb385f7466a69b76.jpg";